import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

const textIntroductionAppear = keyframes`
  from { opacity: 0, }
  to { opacity: 1, }
`

export default makeStyles()(theme => ({
  freelancer: {
    animation: `${keyframes`
      from {
        opacity: 0,
        transform: scale(0),
      }
      to {
        opacity: 1,
        transform: scale(1),
      }
    `} 0.5s cubic-bezier(0.7, 0, 0, 1)`,
    transformOrigin: 'top center',
  },
  cta: {
    textAlign: 'center',
    margin: `${theme.spacing(4)} auto`,
    '& button': {
      margin: theme.spacing(1),
    },
  },
  skills: {
    textAlign: 'center',
    margin: `${theme.spacing(4)} auto`,
    maxWidth: 800,
    boxSizing: 'border-box',
    '@media (min-height: 1000px)': {
      margin: `${theme.spacing(6)} auto`,
    },
  },
  skill: {
    margin: theme.spacing(1),
    display: 'inline-block',
  },
  rating: {
    textAlign: 'center',
    margin: `${theme.spacing(4)} auto`,
    maxWidth: 800,
    boxSizing: 'border-box',
    '@media (min-height: 1000px)': {
      margin: `${theme.spacing(6)} auto`,
    },
  },
  ratingDetails: {
    textAlign: 'center',
    margin: `0 auto ${theme.spacing(4)} auto`,
    maxWidth: 800,
  },
  videoIntroduction: {
    animation: `${textIntroductionAppear} 1s ease`,
    animationDelay: '0.4s',
    animationFillMode: 'backwards',
    '& video': {
      display: 'block',
      margin: '0 auto',
      width: '100%',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
    },
  },
  moreArea: {
    padding: theme.spacing(4),
  },
  sideContent: {
    position: 'absolute',
    left: '100%',
    top: '0',
    minWidth: 300,
    padding: theme.spacing(2),
  },
  tabs: {
    background: 'rgba(224, 233, 242, 0.24)',
    paddingTop: theme.spacing(2),
    '& > div > div': {
      [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
      },
    },
  },
  tab: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: `${theme.spacing(1)} !important`,
      paddingRight: `${theme.spacing(1)} !important`,
    },
    '& > span': {
      flexDirection: 'row !important' as 'row',
    },
    '& > div > div': {
      justifyContent: 'center',
    },
  },
  container: {
    position: 'relative',
  },
  freelancerContent: {
    display: 'flex',
    flexGrow: '4',
    flexDirection: 'column',
    padding: theme.spacing(3),
    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    borderRadius: 2,
    backgroundColor: '#FFF',
  },
  about: {
    lineHeight: 22,
    marginBottom: theme.spacing(1),
  },
  statement: {
    // TODO: lighten() will crash on Turbopack
    color: theme.palette.text.dark, // lighten(theme.palette.text.dark, 0.3),
    margin: theme.spacing(1, 0),
  },
  socialLinksWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  socialLink: {
    margin: theme.spacing(1, 1, 0, 0),
    width: '100%',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },
  freelancerSidebar: {
    flexDirection: 'column',
    flexBasis: 170,
    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    borderRadius: 2,
    backgroundColor: '#FFF',
    marginLeft: theme.spacing(1),
    padding: theme.spacing(3),
    flexGrow: '1',
    flexShrink: '0',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
}))
